(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('stockTransferLoad', {
        templateUrl: 'views/components/views/stockTransferLoad/stockTransferLoad.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'stockTransferLoadService', 'logisticService', function ($stateParams, stateService, utilityService, modalService, translateService, stockTransferLoadService, logisticService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let stockTransferKeyno = $stateParams.stocktransfer_keyno;

            let translations = {
            	error: '',
            	ok: ''
            };

            vm.model = {
                setting: {},
                itemsListOnLocations: [],
                lockedPickFinished: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSetting() {
                vm.model.setting = (await stockTransferLoadService.getStockTransferLoad({ stocktransfer_keyno: stockTransferKeyno }))[0];

                return loadGenericFunction();
            }

            async function loadGenericFunction() {
                if (utilityService.validateParmsValue(vm.model.setting.p2_datatask_keyno_to_run) !== true) return;
                
                return vm.model.itemsListOnLocations = await logisticService.genericFunction(vm.model.setting.p2_datatask_keyno_to_run, vm.model.setting);
            }

		    // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.pickFinishedChanges = function () {
                vm.model.lockedPickFinished = true;

                stockTransferLoadService.pickFinishedObj(vm.model.setting).then(function (response) {
                    if (response[0].errorcode !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                    		message: response[0].errormessage,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: function (dialogItself) {
                    				dialogItself.close();
                    				vm.model.lockedPickFinished = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedPickFinished = false;
                    	stateService.back();
                    }
                });
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadSetting();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
